import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useBooking } from "@/lib/booking";
import { AppointmentForm } from "./Forms";

export function BookingModal() {
  const { open, setOpen, service } = useBooking();
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="booking-modal" className="max-w-2xl bg-ivory rounded-3xl border-pine/10 max-h-[90vh] overflow-y-auto" data-lenis-prevent>
        <DialogHeader>
          <DialogTitle className="font-display text-2xl md:text-3xl font-semibold text-pine-deep">
            Book Your Consultation
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Dyntra Clinics — Sector 75, Noida. Our team will confirm your slot.
          </DialogDescription>
        </DialogHeader>
        <AppointmentForm key={service || "default"} defaultService={service} testidPrefix="modal-appointment-form" />
      </DialogContent>
    </Dialog>
  );
}
